import { defineVariant } from '../v4/theme';

/* v6 "Raster": Swiss/brutalist — flat, square, one signal color, big type. */
export const V6_VARIANT = defineVariant({
  id: 'v6',
  basePath: '/v6',
  brand: 'EcoScope',
  tag: 'v6 · Raster',
  defaultMode: 'light',
  font: '"Space Grotesk","Helvetica Neue",Arial,sans-serif',
  fontsHref: 'https://fonts.googleapis.com/css2?family=Space+Grotesk:wght@400;500;600;700&family=Space+Mono:wght@400;700&display=swap',
  radius: 0,
  tokens: {
    light: {
      bg:            '#f2f2ef',
      text:          '#111111',
      'muted-rgb':   '60,60,60',
      'fg-rgb':      '17,17,17',
      'surface-rgb': '255,255,255',
      'surface2-rgb':'250,250,248',
      'shadow-rgb':  '0,0,0',
      'shadow-k':    '0',
      cyan:          '#ff4d00',
      'cyan-light':  '#ff7033',
      'cyan-deep':   '#c23a00',
      green:         '#0a8f4e',
      red:           '#d0021b',
      'red-soft':    '#d0021b',
      orange:        '#c77700',
      purple:        '#5b3fd6',
      gold:          '#a38200',
      blue:          '#1f4bff',
      teal:          '#00897b',
      neutral:       '#9e9e9e',
      whatsapp:      '#0a8f4e',
      'glow-k':      '0',
    },
    dark: {
      bg:            '#0b0b0b',
      text:          '#f2f2ef',
      'muted-rgb':   '190,190,185',
      'fg-rgb':      '242,242,239',
      'surface-rgb': '20,20,20',
      'surface2-rgb':'16,16,16',
      'shadow-rgb':  '0,0,0',
      'shadow-k':    '0',
      cyan:          '#ff5a1f',
      'cyan-light':  '#ff7a4a',
      'cyan-deep':   '#c43d0c',
      green:         '#2ecc71',
      red:           '#ff3b3b',
      'red-soft':    '#ff5c5c',
      orange:        '#ffb020',
      purple:        '#9b87ff',
      gold:          '#ffd23f',
      blue:          '#5b7bff',
      teal:          '#2ec4b6',
      neutral:       '#555555',
      whatsapp:      '#25d366',
      'glow-k':      '0',
    },
  },
  /* Flat & square everywhere: no rounding, no glass, no glow. */
  globalStyles: () => ({
    '*, *::before, *::after': {
      borderRadius: '0 !important',
      backdropFilter: 'none !important',
      textShadow: 'none !important',
    },
    '.MuiPaper-root, .MuiPopover-paper, .MuiMenu-paper': {
      boxShadow: 'none !important',
      border: '2px solid var(--v4-text) !important',
    },
  }),
});
